import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class UpdateChannelNotificationSound {
  constructor(context) {
    this.context = context;
  }

  run({ channel, type }) {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.setChannelNotificationSound(channel, type);
    setAgentPreferences(this.context, preferences);
  }
}
